<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title id="title">Master Data Maintenance Selection</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSave">
          <div id="Main">
           <div id="selection" v-if="isSelection">
             <table>
              <tr>
                <td>
                  <md-button class="carrierBut" @click="carrierCreate">Carrier</md-button>
                  </td>
                </tr>
              <tr>
                <td>
                  <md-button class="locationBut" @click="locationCreate">Location</md-button>
                  </td>
                </tr>
              <tr>
                <td>
                  <md-button class="routeBut" @click="routeCreate">Route</md-button>
                  </td>
                </tr>
              <tr>
                <td>
                  <md-button class="chassisBut" @click="chassisCreate">Chassis Vendor</md-button>
                  </td>
                </tr>
              <tr>
                <td>
                  <md-button class="lchassisBut" @click="leasechassisCreate">Leasing Chassis</md-button>
                  </td>
                </tr>
              <tr>
                <td>
                  <md-button class="customerBut" @click="customerCreate">Customer</md-button>
                  </td>
                </tr>
              <tr>
                <td>
                  <md-button class="truckBut" @click="truckCreate">Truck</md-button>
                  </td>
                </tr>
              <tr>
                <td>
                  <md-button class="rateBillBut" @click="rateBillCreate">Rate Billing</md-button>
                  </td>
                </tr>
              <tr>
                <td>
                  <md-button class="rateCostBut" @click="rateCostCreate">Rate Cost</md-button>
                  </td>
                </tr>
              <tr>
                <td>
                  <md-button class="allowRecWinBut" @click="allowRecWinCreate">Allow Rec Window</md-button>
                  </td>
              </tr>
              <tr>
                <td>
                  <md-button class="otherBut" @click="otherCreate">Other</md-button>
                  </td>
                </tr>
                </table>
           </div>
           <div id="carrier" v-if="isCarrier"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>STC_CARRIER</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Carrier Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Carrier Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.scacode')">
            <label>SCACODE</label>
            <md-input v-model="dataForm.scacode"/>
          </md-field>


          <md-switch v-model="dataForm.active">Active</md-switch>

              
          </div>
           <div id="location" v-if="isLocation"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>STC LOCATION/TERMINAL</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Location Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Location Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.street')">
            <label>Street</label>
            <md-input v-model="dataForm.street"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.city')">
            <label>City</label>
            <md-input v-model="dataForm.city"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.state')">
            <label>State</label>
            <md-input v-model="dataForm.state"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.zip')">
            <label>Zip</label>
            <md-input v-model="dataForm.zip"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.country')">
            <label>Country</label>
            <md-input v-model="dataForm.country"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.contactperson')">
            <label>Contact Person</label>
            <md-input v-model="dataForm.contactPerson"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.contacttel')">
            <label>Contact Tel</label>
            <md-input v-model="dataForm.contactTel"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>

              
          </div>
           <div id="route" v-if="isRoute"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>GST_ROUTE</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Route Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Route Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.stage')">
            <label>Stage</label>
            <md-input v-model="dataForm.stage"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.dept')">
            <label>Departure point</label>
            <md-input v-model="dataForm.dept"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.dest')">
            <label>Destination point</label>
            <md-input v-model="dataForm.dest"/>
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>

              
          </div>
           <div id="chassis" v-if="isChassis"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>STC_CHASSIS_VENDOR</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Vendor Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Vendor Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>
          <md-field :class="getValidationClass('dataForm.chassisVendorType')">
            <label>Vendor Type</label>
            <md-input v-model="dataForm.chassisVendorType"/>
            <!--<span class="md-error" v-if="!$v.dataForm.chassisVendorType.required">Tag Name is required</span>-->
          </md-field>
          <!-- 
             <datepicker v-model="dataForm.validPeriod" >
              <label>Valid Period</label>
             </datepicker> 
            --> 
            <auto-complete-select
               label="Sale Office"
               :options="this.getSaleOfficeMasterData"
               v-model="dataForm.saleoffice"
            />   

          <md-switch id="active" v-model="dataForm.active" v-if="isActive">Active</md-switch>

              
          </div>
           <div id="customer" v-if="isCustomer"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>GST_CUSTOMER</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.group.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Customer Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Customer Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-switch id="active" v-model="dataForm.active" v-if="isActive">Active</md-switch>

              
          </div>
           <div id="leasechassis" v-if="isLeaseChassis"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>GST_LEASINGCHASSIS</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Leasing Chassis Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Sale Office</label>

            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.vendor')">
            <label>Vendor</label>
            <md-input v-model="dataForm.vendor"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.equipsize')">
            <label>Equipment Size</label>
            <md-input v-model="dataForm.equipsize"/>
          </md-field>

          <md-switch id="active" v-model="dataForm.active" v-if="isActive">Active</md-switch>

          </div>

          <div id="driverCompany" v-if="isDriverCompany"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>STC_DRIVER_COMPANY</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <!--
          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>
        -->
          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Driver Company</label>

            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.amtScaleAddition1')">
            <label>Scale Addition</label>
            <md-input v-model="dataForm.amtScaleAddition1"/>
          </md-field>
          <md-field :class="getValidationClass('dataForm.amtScaleDeduction1')">
            <label>Scale Deduction</label>
            <md-input v-model="dataForm.amtScaleDeduction1"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.amtManifestAddition1')">
            <label>Manifest Addition</label>
            <md-input v-model="dataForm.amtManifestAddition1"/>
          </md-field>
          <md-field :class="getValidationClass('dataForm.amtManifestDeduction1')">
            <label>Manifest Deduction</label>
            <md-input v-model="dataForm.amtManifestDeduction1"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.amtParkingAddition1')">
            <label>Parking Addition</label>
            <md-input v-model="dataForm.amtParkingAddition1"/>
          </md-field>
          <md-field :class="getValidationClass('dataForm.amtParkingDeduction1')">
            <label>Parking Deduction</label>
            <md-input v-model="dataForm.amtParkingDeduction1"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.amtInsuranceAddition1')">
            <label>Insurance Addition</label>
            <md-input v-model="dataForm.amtInsuranceAddition1"/>
          </md-field>
          <md-field :class="getValidationClass('dataForm.amtInsuranceDeduction1')">
            <label>Insurance Deduction</label>
            <md-input v-model="dataForm.amtInsuranceDeduction1"/>
          </md-field>


          <md-switch id="active" v-model="dataForm.active" v-if="isActive">Active</md-switch>

          </div>

          <div id="truck" v-if="isTruck"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>GST_TRUCK</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Truck Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Truck Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Truck Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Truck Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.saleoffice')">
            <auto-complete-select
               label="Sale Office"
               :options="this.getSaleOfficeMasterData"
               v-model="dataForm.saleoffice"
            />   
          </md-field>

          <md-switch id="active" v-model="dataForm.active" v-if="isActive">Active</md-switch>

              
          </div>

            <div id="rateBill" v-if="isRateBill"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>GST_RATE_BIILLING</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Rate Type</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Truck Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Description</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Truck Name is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.measureUnit')">
            <label>Measure Unit</label>
            <md-input v-model="dataForm.measureUnit"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.category')">
            <label>Category</label>
            <md-input v-model="dataForm.category"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.cntrType')">
            <label>Container Type</label>
            <md-input v-model="dataForm.cntrType"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.customer')">
            <label>Customer</label>
            <md-input v-model="dataForm.customer"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.location')">
            <label>Location</label>
            <md-input v-model="dataForm.location"/>
          </md-field>

            <auto-complete-select
               label="Sale Office"
               :options="this.getSaleOfficeMasterData"
               v-model="dataForm.saleoffice"
            />   

          <md-switch id="active" v-model="dataForm.active" v-if="isActive">Active</md-switch>

              
          </div>
            <div id="rateCost" v-if="isRateCost"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>GST_RATE_COST</label>
            <md-input disabled v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Rate Type</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Truck Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Description</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Truck Name is required</span>
          </md-field>


          <md-field :class="getValidationClass('dataForm.measureUnit')">
            <label>Measure Unit</label>
            <md-input v-model="dataForm.measureUnit"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.category')">
            <label>Category</label>
            <md-input v-model="dataForm.category"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.cntrType')">
            <label>Container Type</label>
            <md-input v-model="dataForm.cntrType"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.customer')">
            <label>Customer</label>
            <md-input v-model="dataForm.customer"/>
          </md-field>

          <md-field :class="getValidationClass('dataForm.location')">
            <label>Location</label>
            <md-input v-model="dataForm.location"/>
          </md-field>

            <auto-complete-select
               label="Sale Office"
               :options="this.getSaleOfficeMasterData"
               v-model="dataForm.saleoffice"
            />   

          <md-switch id="active" v-model="dataForm.active" v-if="isActive">Active</md-switch>

              
          </div>

          <div id="allowRecWin" v-if="isAllowRecWindow"> 
            <md-field :class="getValidationClass('dataForm.group')">
              <label>Group</label>
              <md-input disabled v-model="dataForm.group"/>
                <span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>
              </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Desc</label>
            <md-input v-model="dataForm.tagName"/>
          </md-field>

          <auto-complete-master-data-select
                                                group="OFFICE_IP"
                                                label="Location/Office"
                                                displayType="idOnly"
                                                :init-value="dataForm.location"
                                                :watchValueId="dataForm.location"
                                                :on-item-changed="handleLocationChanged"
                                                >
          </auto-complete-master-data-select>


          <auto-complete-master-data-select
                                                group="REC_WINDOW"
                                                label="Receiving Windows"
                                                :init-value="dataForm.recWindow"
                                                :watchValueId="dataForm.recWindow"
                                                :on-item-changed="handleWindowsChanged"
                                                >
          </auto-complete-master-data-select>


          <md-switch id="active" v-model="dataForm.active" v-if="isActive">Active</md-switch>

              
          </div>


          <div id="other" v-if="isOther"> 
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input v-model="dataForm.group"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Tag Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Tag Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Truck Name is required</span>
          </md-field>

          <md-switch id="active" v-model="dataForm.active" v-if="isActive">Active</md-switch>
              
          </div>


           </div>
          <calling-api type="bar" path="/api/w/masterData/update">
            <md-dialog-actions>
              <md-button class="md-primary" @click="closeDialog">Close</md-button>
              <md-button type="submit" class="md-primary" id="save" v-if="isSave">Save</md-button>            
            </md-dialog-actions>
          </calling-api>
        </form>

      </md-dialog-content>
    </md-dialog>
  </div>
</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  };

  .carrierBut .locationBut .customerBut .chassisBut .lchassisBut .truckBut .routeBut{
   display:'inline-block';
   padding:'0.7em 1.7em';
   margin:'0 0.3em 0.3em 0';
   border-radius:'0.2em';
   box-sizing:'border-box';
   text-decoration:'none';
   font-family:'Roboto',scans-serif;
   font-weight:'400';
   color:'#FFFFFF';
   background-color:'#3369ff';
   box-shadow:'inset 0 -0.6em 1em -0.35em rgba(0,0,0,0.17),inset 0 0.6em 2em -0.3em rgba(255,255,255,0.15),inset 0 0 0em 0.05em rgba(255,255,255,0.12)';
   text-align:'center';
   position:'relative';
  }
  

</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { required, } from 'vuelidate/lib/validators';
import DatePicker from './DatePicker.vue';
import AutocompleteMasterDataMultipleSelect from './AutocompleteMasterDataMultipleSelect.vue';

  const getInitialDataForm = () => ({
    group: null,
    tagId: null,
    tagName: null,
    parentGroup: null,
    parentTagId: null,
    active: true,
    scacode: null,
    street: null,
    city: null,
    state: null,
    zip: null,
    country: null,
    contactPerson: null,
    contactTel: null,
    stage: null,
    deptPoint: null,
    destPoint: null,
    saleoffice: null,
    vendor: null,
    equipsize: null,
    validPeriod: null,
    measureUnit: null,
    category: null,
    cntrType: null,
    customer: null,
    location: null,
    recWindow: null,
    chassisVendorType: null,
    amtScaleAddition1: null,
    amtScaleDeduction1: null,
    amtManifestAddition1: null,
    amtManifestDeduction1: null,
    amtParkingAddition1: null,
    amtParkingDeduction1: null,
    amtInsuranceAddition1: null,
    amtInsuranceDeduction1: null
  });

 const getDriverCompanyDataForm = () => ({
    group: null,
    tagId: null,
    tagName: null,
    active: true,
    amtScaleAddition1: null,
    amtScaleDeduction1: null,
    amtManifestAddition1: null,
    amtManifestDeduction1: null,
    amtParkingAddition1: null,
    amtParkingDeduction1: null,
    amtInsuranceAddition1: null,
    amtInsuranceDeduction1: null
  });

  
  export default {
  components: { DatePicker, AutocompleteMasterDataMultipleSelect },
    mixins: [validationMixin],
    props: {
      mode: String,
      onUpdate: Function,
    },
    data: () => ({
      showDialog: false,
      stores: [],
      dispatchers: [],
      //dataForm: getCarrierDataForm(),
      dataForm: getInitialDataForm(),
      isCarrier: false,
      isSelection: true,
      isLocation: false,
      isRoute: false,
      isChassis: false,
      isCustomer: false,
      isLeaseChassis: false,
      isDriverCompany: false,
      isOther: false,
      isTruck: false,
      isRateBill: false,
      isRateCost: false,
      isAllowRecWindow: false,
      isActive: false,
      isSave: false,
    }),

    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getSaleOfficeMasterData',
        'getSaleOfficeByName',
        'getMasterDataName',
      ]),
      getDispatcherInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.dispatcherName} (${this.dataForm.dispatcherId})`;
      },
      getSpecialStatusInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.statusName} (${this.dataForm.statusId})`;
      },
    },
    watch: {},
    validations: {
      dataForm: {
        group: {
          required,
        },
        tagId: {
          required,
        },
        tagName: {
          required,
        },
      },
    },
    methods: {
      openDialog(existingData,type) {
        //this.dataForm = getCarrierDataForm();
        //console.log("getter: " + this.getSaleOfficeByName('Long Beach')[0].tagId);

        
        this.dataForm = getInitialDataForm();
        this.$v.dataForm.$reset();
        console.log(type);
        console.log(`openDialog`, existingData);
        if (existingData && this.mode === 'update') {
          this.dataForm.group = existingData.group;
          this.dataForm.tagId = existingData.tagId;
          this.dataForm.tagName = existingData.tagName;
          this.dataForm.active = existingData.active;
          //this.dataForm.scacode = existingData.scacode;
          this.dataForm.amtScaleAddition1 = existingData.amtScaleAddition1;
          this.dataForm.amtScaleDeduction1 = existingData.amtScaleDeduction1;
          this.dataForm.amtManifestAddition1 = existingData.amtManifestAddition1;
          this.dataForm.amtManifestDeduction1 = existingData.amtManifestDeduction1;
          this.dataForm.amtParkingAddition1 = existingData.amtParkingAddition1;
          this.dataForm.amtParkingDeduction1 = existingData.amtParkingDeduction1;
          this.dataForm.amtInsuranceAddition1 = existingData.amtInsuranceAddition1;
          this.dataForm.amtInsuranceDeduction1 = existingData.amtInsuranceDeduction1;
        } else {
          if (this.mode === 'createcarrier') {
             this.carrierCreate(); 
          } else if (this.mode === 'createlocation') {
             this.locationCreate();
          } else if (this.mode === 'createchassis') {
             this.chassisCreate(); 
          } else if (this.mode === 'createleasechassis') {
             this.leasechassisCreate();
          } else if (this.mode === 'createcustomer') {
             this.customerCreate();
          } else if (this.mode === 'createtruck') {
             this.truckCreate();
          } else if (this.mode === 'createdrivercompany') {
             this.driverCompanyCreate();
          }
        }

        this.showDialog = true;
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      doSave() {
        this.$v.dataForm.$touch();
        if (this.dataForm.group === "STC_DRIVER_COMPANY")
           this.dataForm.tagId = "dummy";
           
        if (this.dataForm.amtScaleAddition1 && this.dataForm.amtScaleAddition1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtScaleAddition1))
           {
               alert("Scale Addition amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtScaleDeduction1 && this.dataForm.amtScaleDeduction1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtScaleDeduction1))
           {
               alert("Scale Deduction amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtManifestAddition1 && this.dataForm.amtManifestAddition1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtManifestAddition1))
           {
               alert("Manifest Addition amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtManifestDeduction1 && this.dataForm.amtManifestDeduction1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtManifestAddition1))
           {
               alert("Manifest Deduction amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtParkingAddition1 && this.dataForm.amtParkingAddition1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtParkingAddition1))
           {
               alert("Parking Addition amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtParkingDeduction1 && this.dataForm.amtParkingDeduction1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtParkingDeduction1))
           {
               alert("Parking Deduction amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtInsuranceAddition1 && this.dataForm.amtInsuranceAddition1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtInsuranceAddition1))
           {
               alert("Insurance Addition amount needs to be numeric or demical!");
               return;
           }
        if (this.dataForm.amtInsuranceDeduction1 && this.dataForm.amtInsuranceDeduction1 != "")
           if (!/^[+-]?\d+(\.\d+)?$/.test(this.dataForm.amtInsuranceDeduction1))
           {
               alert("Insurance Deduction amount needs to be numeric or demical!");
               return;
           }


        if (this.dataForm.group === "ALLOW_REC_WIN")
        {
           if (this.dataForm.location == null || this.dataForm.location == "")
           {
               alert("Location/Office cannot be empty!");
               return;
           }
           if (this.dataForm.recWindow == null || this.dataForm.recWindow == "")
           {
               alert("Receiving Window cannot be empty!");
               return;
           }
           this.dataForm.tagId = this.dataForm.location.replaceAll(' ','') + "_" + this.dataForm.recWindow;
        } 

        if (this.$v.dataForm.$invalid) {
          console.log("data form is invalid");
          return;
        }
        //console.log("sale office for chassis vendor (before): " + this.dataForm.saleoffice);   

        //console.log("getter: " + JSON.stringify(this.getSaleOfficeByName(this.dataForm.saleoffice).tagId));
        if (this.getSaleOfficeByName('Long Beach').length > 0)
           this.dataForm.saleoffice = this.getSaleOfficeByName('Long Beach')[0].tagId;
        else
           this.dataForm.saleoffice = "";   

        //console.log("sale office for chassis vendor: " + this.dataForm.saleoffice);   

        this.$store
          .dispatch(
            "updateMasterData",
            this.dataForm,
          )
          .then(() => {
            //this.showDialog = false;
            this.closeDialog();
            this.onUpdate();
          });
      },
      handleWindowsChanged(id) {
        this.dataForm.recWindow = id;
      },
      handleLocationChanged(id) {
        this.dataForm.location = id;
      },
      carrierCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Carrier Data Creation";
        this.dataForm.group = "STC_CARRIER";
        this.isCarrier = true;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = false;
        this.isRoute = false;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isAllowRecWindow = false;
        this.isActive = true;
        this.showDialog = true
      },
      locationCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Location Data Creation";
        this.dataForm.group = "STC_TERMINAL";
        this.isCarrier = false;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = true;
        this.isRoute = false;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isAllowRecWindow = false;
        this.isActive = true;
        this.showDialog = true
      },
      routeCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Route Data Creation";
        this.dataForm.group = "GST_ROUTE";
        this.isCarrier = false;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = false;
        this.isRoute = true;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isAllowRecWindow = false;
        this.isActive = true;
        this.showDialog = true
      },
      chassisCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Chassis Vendor Data Creation";
        this.dataForm.group = "STC_CHASSIS_VENDOR";
        this.isCarrier = false;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = false;
        this.isRoute = false;
        this.isChassis = true;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isAllowRecWindow = false;
        this.isActive = false;
        this.showDialog = true
      },
      leasechassisCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Leasing Chassis Data Creation";
        this.dataForm.group = "GST_LEASECHASSIS";
        this.isCarrier = false;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = false;
        this.isRoute = false;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = true;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isAllowRecWindow = false;
        this.isActive = true;
        this.showDialog = true
      },
      driverCompanyCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Driver Company Data Creation";
        this.dataForm.group = "STC_DRIVER_COMPANY";
        this.isCarrier = false;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = false;
        this.isRoute = false;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = true;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isAllowRecWindow = false;
        this.isActive = true;
        this.showDialog = true
      },
      customerCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Customer Data Creation";
        //this.dataForm.group = "GST_CUSTOMER";
        this.dataForm.group = "STC_CUSTOMER";
        this.isCarrier = false;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = false;
        this.isRoute = false;
        this.isChassis = false;
        this.isCustomer = true;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isAllowRecWindow = false;
        this.isActive = true;
        this.showDialog = true
      },
      truckCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Truck Data Creation";
        this.dataForm.group = "GST_TRUCK";
        this.isCarrier = false;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = false;
        this.isRoute = false;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = true;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isAllowRecWindow = false;
        this.isActive = true;
        this.showDialog = true
      },
      rateBillCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Rate Billing Data Creation";
        this.dataForm.group = "GST_RATE_BILLING";
        this.isCarrier = false;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = false;
        this.isRoute = false;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = true;
        this.isRateCost = false;
        this.isAllowRecWindow = false;
        this.isActive = true;
        this.showDialog = true
      },
      rateCostCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Rate Cost Data Creation";
        this.dataForm.group = "GST_RATE_COST";
        this.isCarrier = false;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = false;
        this.isRoute = false;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = true;
        this.isAllowRecWindow = false;
        this.isActive = true;
        this.showDialog = true
      },
      allowRecWinCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Allow Rec Window Creation";
        this.dataForm.group = "ALLOW_REC_WIN";
        this.isCarrier = false;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = false;
        this.isRoute = false;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isAllowRecWindow = true;
        this.isActive = true;
        this.showDialog = true

      },
      otherCreate() {
        const titleElm = document.getElementById("title");
        if (titleElm)
           titleElm.innerText = "Master Data Creation";
        //this.dataForm.group = "GST_TRUCK";
        this.isCarrier = false;
        this.isSave = true;
        this.isSelection = false;
        this.isLocation = false;
        this.isRoute = false;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = true;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isActive = true;
        this.showDialog = true
      },
      resetVar() {
        this.isCarrier = false;
        this.isSelection = true;
        this.isLocation = false;
        this.isRoute = false;
        this.isSave = false;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isAllowRecWindow = false;
      },
      closeDialog() {
        this.isCarrier = false;
        this.isSelection = true;
        this.isLocation = false;
        this.isRoute = false;
        this.isSave = false;
        this.isChassis = false;
        this.isCustomer = false;
        this.isLeaseChassis = false;
        this.isDriverCompany = false;
        this.isOther = false;
        this.isTruck = false;
        this.isRateBill = false;
        this.isRateCost = false;
        this.isAllowRecWindow = false;
        this.showDialog = false;
      }
    },
  };
</script>
